import { render, staticRenderFns } from "./OrderReference.vue?vue&type=template&id=08b8c6e4&scoped=true&"
import script from "./OrderReference.vue?vue&type=script&lang=js&"
export * from "./OrderReference.vue?vue&type=script&lang=js&"
import style0 from "./OrderReference.vue?vue&type=style&index=0&id=08b8c6e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b8c6e4",
  null
  
)

export default component.exports